import React from "react";

const AboutUs = () => {
  const aboutSections = [
    {
      title: "Who We Are",
      content: [
        "Lazmy is more than just an e-commerce platform; we’re a community-driven marketplace committed to connecting people with products they love. From daily essentials to the latest trends, we strive to bring convenience, affordability, and reliability to every corner of Pakistan.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Our Vision",
      content: [
        "To empower every household in Pakistan by making shopping effortless, accessible, and enjoyable while ensuring our customers receive the best value for their money.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Our Values",
      content: [
        "Customer First: Your satisfaction is our priority. We listen, we care, and we adapt to meet your needs.",
        "Quality Assurance: Lazmy partners with trusted vendors and brands to ensure every product meets our high standards.",
        "Innovation: We leverage the latest technology to make your shopping journey seamless and secure.",
        "Sustainability: We're committed to minimizing our environmental footprint by adopting eco-friendly practices in our operations.",
      ],
      isList: true,
      icon: "bi-check-circle",
      iconColor: "text-success",
    },
    {
      title: "What We Offer",
      content: [
        "A wide range of categories including electronics, fashion, home essentials, beauty, and more.",
        "Cash on Delivery (COD) for hassle-free payments.",
        "Free shipping on eligible orders with timely and reliable delivery.",
        "A user-friendly platform with personalized recommendations and easy navigation.",
        "Exclusive deals, discounts, and seasonal promotions tailored to your preferences.",
      ],
      isList: true,
      icon: "bi-check-circle",
      iconColor: "text-success",
    },
    {
      title: "Why Choose Lazmy?",
      content: [
        "With Lazmy, you get more than just a shopping platform—you gain a trusted partner in your everyday needs. Whether you're looking for the perfect gift, upgrading your lifestyle, or stocking up on essentials, Lazmy is here to make it happen.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Join Us in Shaping the Future of Shopping",
      content: [
        "We believe in the power of community and collaboration. That’s why we continuously strive to improve our services and deliver an unmatched shopping experience for every customer.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
  ];

  return (
    <section className="container container-lg py-5 px-40">
      <h2 className="text-center mb-4 text-3xl  fw-bold">About Lazmy</h2>
      <div className="flex-center w-100">
        <p className="text-center text-muted mb-5 col-lg-7 col-md-8 col-sm-12">
          Welcome to Lazmy, Pakistan's premier online shopping destination! At
          Lazmy, we’re on a mission to redefine the shopping experience for
          customers across the country by offering a diverse range of
          high-quality products at unbeatable prices—all from the comfort of
          your home.
        </p>
      </div>

      {aboutSections.map((section, index) => (
        <div key={index} className="my-20">
          <h3 className="text-xl mb-4 font-weight-bold">{section.title}</h3>
          {section.isList ? (
            <ul className="list-unstyled">
              {section.content.map((item, idx) => (
                <li
                  key={idx}
                  className="d-flex align-items-lg-center align-items-sm-start justify-content gap-4 mb-3"
                >
                  <i
                    className={`bi ${section.icon} ${section.iconColor} me-3`}
                    style={{ fontSize: "1.5rem" }}
                    aria-label={section.title}
                  ></i>
                  <div
                    className="text-muted mb-5"
                    dangerouslySetInnerHTML={{ __html: item }}
                  ></div>
                </li>
              ))}
            </ul>
          ) : (
            section.content.map((item, idx) => (
              <p
                key={idx}
                className="text-muted mb-5"
                dangerouslySetInnerHTML={{ __html: item }}
              ></p>
            ))
          )}
        </div>
      ))}
    </section>
  );
};

export default AboutUs;
